import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const hostname = window.location.hostname;

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/:id",
    name: "fahrzeug",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "fahrzeug" */ "../views/Fahrzeug.vue"),
    props: true,
  },
];

const baseUrls = {
  uniqehorn: "/fsales/dev/vue/",
  luxner: "/gebrauchtwagen/",
  kammerhofer: "/gebrauchtwagen/",
  lauer: "/gebrauchtwagen/",
  langebner: "/lagerwagen/gebrauchtwagen/",
  rdv: "/gebrauchtwagen/",
  polke: "/lagerwagen/fahrzeuge/",
  rdw: "/gebrauchtwagen/",
  autoebner: "/fahrzeugboerse/lagerwagen/",
};

const router = new VueRouter({
  mode: "history",
  routes,
  base: baseUrls[process.env.VUE_APP_HAENDLER] || "/gebrauchtwagen/",
});

export default router;
